/* eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/core/i18n/i18n.js";
import vSelect from "vue-select";
import Toast from "vue-toastification";
import AOS from "aos";
import Maska from "maska";
import naive, { useNotification } from "naive-ui";
import VueSocialSharing from "vue-social-sharing";
import CContent from "@/components/CContent.vue";
import COverlay from "@/components/COverlay.vue";
import vClickOutside from "click-outside-vue3";
import Vue3Toasity from "vue3-toastify";

import InlineSvg from "vue-inline-svg";
import { naiveNotificationPlugin } from "./plugins/naiveNotification";

import "aos/dist/aos.css";
import "vue-select/dist/vue-select.css";
import "vue3-toastify/dist/index.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "vue-toastification/dist/index.css";
import "@/assets/scss/main.scss";
import "./assets/tailwind.css";

import "vue-toast-notification/dist/theme-sugar.css";
import ToastPlugin from "vue-toast-notification";

import ApiService from "./services/api.service";
import { TokenService } from "./services/storage.service";
import { create, NConfigProvider, NNotificationProvider } from "naive-ui";
// SET THE BASE_URL OF THE API
ApiService.init(process.env.VUE_APP_ROOT_API);
ApiService.mount401Interceptor();
ApiService.setLanguage();

if (TokenService.getToken()) {
    ApiService.setHeader();
    ApiService.mount401Interceptor();
}

const naiveUI = create({
    components: [
        NConfigProvider, // ← MUHIM: Asosiy provider
        NNotificationProvider,
    ],
});

const app = createApp(App);

// global components
app.component("CContent", CContent);
app.component("COverlay", COverlay);

app.use(VueSocialSharing);

app.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
});

app.use(naiveUI);
app.use(naiveNotificationPlugin);

app.use(
    AOS.init({
        once: true,
    })
);
const baseUrl = process.env.VUE_APP_ROOT_URL;
const baseUrl2 = process.env.VUE_APP_ROOT_URL2;
const baseDocUrl = process.env.VUE_APP_DOC_SERVER_URL;

import Util from "@/core/utils/globalMethods";
// timetype
app.config.globalProperties.$getName = Util.getName;
app.config.globalProperties.$localeKey = Util.localeKey;
app.config.globalProperties.$timetype = Util.timetype;
app.config.globalProperties.$showError = Util.showError;
app.config.globalProperties.$showCustomToast = Util.showCustomToast;
app.config.globalProperties.$errorMsg = Util.errorMsg;
app.config.globalProperties.$showSuccess = Util.showSuccess;
app.config.globalProperties.$showInfo = Util.showInfo;
app.config.globalProperties.$successMsg = Util.successMsg;
app.config.globalProperties.$showWarning = Util.showWarning;
app.config.globalProperties.$getImgPath = Util.getImgPath;
app.config.globalProperties.$baseUrl = baseUrl;
app.config.globalProperties.$baseUrl2 = baseUrl2;
app.config.globalProperties.$baseDocUrl = baseDocUrl;
app.config.globalProperties.$showNaiveSuccess = Util.showNaiveSuccess;
app.config.globalProperties.$showNaiveError = Util.showNaiveError;
app.config.globalProperties.$showNaiveWarning = Util.showNaiveWarning;
app.config.globalProperties.$showNaiveInfo = Util.showNaiveInfo;
import "./dateProtypes";

app.component("v-select", vSelect);
app.use(Maska);
app.use(ToastPlugin);
app.use(Vue3Toasity);
app.use(vClickOutside);
app.use(naive);
app.component("inline-svg", InlineSvg);
app.use(VueSocialSharing);
app.use(i18n);
app.use(store);
app.use(router);
app.mount("#app");

const portalRatingLangMap = {
    lt: "uz",
    uz: "cyrl",
    ru: "ru",
    eng: "en",
};

const portalRatingBlockedHosts = ["t.e-advokat.uz"];
const portalRatingBlockedPathPrefixes = ["/lawyer-profile"];

function shouldShowPortalRatingWidget(route) {
    return (
        !portalRatingBlockedPathPrefixes.some((pathPrefix) =>
            route.path.startsWith(pathPrefix)
        ) &&
        !portalRatingBlockedHosts.includes(window.location.hostname)
    );
}

function loadPortalRatingWidget(route) {
    if (!shouldShowPortalRatingWidget(route)) {
        return;
    }

    if (document.getElementById("portal-rating-widget-script")) {
        return;
    }

    const currentLang = localStorage.getItem("language") || "lt";
    const script = document.createElement("script");

    script.id = "portal-rating-widget-script";
    script.src = "https://muloqot.gov.uz/api/v1/portalRating.js";
    script.async = true;
    script.dataset.lang = portalRatingLangMap[currentLang] || "uz";
    script.dataset.position = "bottom-right";
    script.dataset.offsetX = "50";
    script.dataset.offsetY = "80";
    script.dataset.color = "#2563EB";
    script.dataset.textColor = "#ffffff";
    script.dataset.title = "E-advokat xizmatini baholang";
    script.dataset.btnText = "Baholash";
    script.onload = () => {
        if (!shouldShowPortalRatingWidget(router.currentRoute.value)) {
            removePortalRatingWidget();
        }
    };

    document.body.appendChild(script);
}

function removePortalRatingWidget() {
    document.getElementById("portal-rating-widget-script")?.remove();
    document.getElementById("emq-rat-wrapper")?.remove();

    document.querySelectorAll("style").forEach((style) => {
        if (style.textContent?.includes("#emq-rat-wrapper")) {
            style.remove();
        }
    });
}

function syncPortalRatingWidget(route) {
    if (shouldShowPortalRatingWidget(route)) {
        loadPortalRatingWidget(route);
    } else {
        removePortalRatingWidget();
    }
}

router.isReady().then(() => {
    syncPortalRatingWidget(router.currentRoute.value);
});

router.afterEach((to) => {
    syncPortalRatingWidget(to);
});
